function Plus({ fill = "#2E5BFF" }) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5312 5.53125H6.46875V0.46875C6.46875 0.209859 6.25889 0 6 0C5.74111 0 5.53125 0.209859 5.53125 0.46875V5.53125H0.46875C0.209859 5.53125 0 5.74111 0 6C0 6.25889 0.209859 6.46875 0.46875 6.46875H5.53125V11.5312C5.53125 11.7901 5.74111 12 6 12C6.25889 12 6.46875 11.7901 6.46875 11.5312V6.46875H11.5312C11.7901 6.46875 12 6.25889 12 6C12 5.74111 11.7901 5.53125 11.5312 5.53125Z"
        fill={fill}
      />
    </svg>
  );
}

export default Plus;
